import { PlusCircleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { AuthenticatedRoutes } from '@/router/routes';

/**
 * This component represent planner empty state.
 * When server return empty response without any filters
 */
export const PlannerEmptyState = () => {
  const { t } = useTranslation(['authenticated.planner']);

  const navigate = useNavigate();

  const handleTeamPageNavigate = () => navigate(AuthenticatedRoutes.TeamAddMember);

  return (
    <div className="absolute top-[6.2rem] py-[22px] pl-48 pr-4">
      <div className="mb-0.5 text-sm font-medium">{t('emptyState.title')}</div>
      <div className="mb-3 text-xs text-muted-foreground">{t('emptyState.description')}</div>
      <div className="flex gap-2">
        <Button onClick={handleTeamPageNavigate}>
          <PlusCircleIcon />
          {t('emptyState.addMember')}
        </Button>
      </div>
    </div>
  );
};
